/**
 * Created by Codeww
 * on 2019-06-17 18:26
 *
 * @format
 */
import RankDevice from './device';
import globalParams from '../utils/globalParams';
const { Platform, StatusBar } = require('react-native');
import { JDNativeSystem } from '@jdreact/jdreact-core-lib';
const Steep = {
  MOVE_LIMIT: 230,
  NAVIGATION_BAR_HEIGHT: 44,
  SYS_BAR_HEIGHT:
    Platform.OS === 'ios' ? JDNativeSystem.statusBarHeight : Platform.OS === 'android' ? StatusBar.currentHeight : 0,
  /**
   * 获取现在的沉浸式头部状态
   */
  _getSteepStatus() {
    let isTransparent = globalParams.transparentenable;
    try {
      //如果传入的是string，则在此处理
      if (typeof isTransparent === 'string') {
        isTransparent = isTransparent === 'true';
      }
    } catch (error) {
      isTransparent = false;
    }
    return isTransparent;
  },
  /**
   * 获取头部透明块的高度
   */
  _getSteepBarHeight() {
    let height = 0;
    if (Platform.OS === 'ios') {
      height = JDNativeSystem.statusBarHeight;
    } else if (Platform.OS === 'android') {
      const transparent = this._getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (RankDevice.isLowSdkVersion(transparent)) {
        height = 0;
      } else {
        height = StatusBar.currentHeight;
      }
    }
    return height;
  },
  /**
   * 获取内容区域调整大小
   */
  _getContainerChangeHeight() {
    let height = 0;
    if (Platform.OS === 'android') {
      const transparent = this._getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (RankDevice.isLowSdkVersion(transparent)) {
        height = 0;
      } else {
        height = StatusBar.currentHeight;
      }
    }
    return height;
  },
  /**
   * 获取导航栏高度
   */
  _getNavHeight() {
    let height = this.NAVIGATION_BAR_HEIGHT;
    if (Platform.OS === 'ios') {
      height += JDNativeSystem.statusBarHeight;
    } else if (Platform.OS === 'android') {
      const transparent = this._getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (!RankDevice.isLowSdkVersion(transparent)) {
        height += this.SYS_BAR_HEIGHT;
      }
    }
    return height;
  },
};

export default Steep;
